import type { UserProfile } from "@/features/auth/types";

export const platformRoles = [
  "admin",
  "platform_manager",
  "project_manager",
  "analyst",
  "support_agent",
  "client"
] as const;

export type PlatformRole = (typeof platformRoles)[number];

export const administrativeRoles = ["admin", "platform_manager"] as const satisfies PlatformRole[];
export const administrationAccessRoles = [
  "admin",
  "platform_manager",
  "project_manager",
  "analyst",
  "support_agent"
] as const satisfies PlatformRole[];
export const projectAdministrationRoles = [
  "admin",
  "platform_manager",
  "project_manager"
] as const satisfies PlatformRole[];
export const projectTechnicalRoles = [
  "admin",
  "platform_manager",
  "project_manager",
  "analyst"
] as const satisfies PlatformRole[];
export const projectWorkspaceRoles = [
  "admin",
  "platform_manager",
  "project_manager",
  "analyst",
  "client"
] as const satisfies PlatformRole[];
export const teamWorkspaceRoles = [
  "admin",
  "platform_manager",
  "project_manager"
] as const satisfies PlatformRole[];
export const operationalRoles = [
  "admin",
  "platform_manager",
  "project_manager",
  "analyst"
] as const satisfies PlatformRole[];
export const supportRoles = [
  "admin",
  "platform_manager",
  "project_manager",
  "support_agent"
] as const satisfies PlatformRole[];
export const supportPortalRoles = [
  "admin",
  "platform_manager",
  "project_manager",
  "analyst",
  "client"
] as const satisfies PlatformRole[];

export const roleLabels: Record<PlatformRole, string> = {
  admin: "Administrador",
  platform_manager: "Gestor da plataforma",
  project_manager: "Editor / gestor de processos",
  analyst: "Analista",
  support_agent: "Suporte",
  client: "Cliente"
};

const platformRoleSet = new Set<string>(platformRoles);

export function getUserPlatformRoles(profile?: UserProfile | null): PlatformRole[] {
  return (profile?.roles ?? []).filter((role): role is PlatformRole => platformRoleSet.has(role));
}

export function hasAnyPlatformRole(
  profile: UserProfile | null | undefined,
  roles: readonly PlatformRole[]
) {
  const userRoles = getUserPlatformRoles(profile);
  return roles.some((role) => userRoles.includes(role));
}

export function hasAdministrativeAccess(profile?: UserProfile | null) {
  return hasAnyPlatformRole(profile, administrativeRoles);
}

export function hasAdministrationAccess(profile?: UserProfile | null) {
  return hasAnyPlatformRole(profile, administrationAccessRoles);
}
